import { css, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  activities: css`
    display: flex;
    align-items: center;
  `,
  activity: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    color: ${theme.colors.primary.fuchsia[50]};
    background-color: ${theme.colors.primary.fuchsia[10]};
    cursor: pointer;
    border-radius: 11px;
    outline: 2px solid white;

    ${extractTransition((f) => f.cubic, { property: ['background-color', 'color'], duration: 220 })}

    &:hover {
      color: white;
      background-color: ${theme.colors.primary.fuchsia[50]};
    }
  `,
  activityIcon: css`
    height: 22px;
    width: 22px;

    margin-right: -2px;
  `,
  activityFull: css`
    gap: 4px;
    padding: 0px 8px 0px 4px;
    height: 22px;
  `,
  tooltipLabel: css`
    white-space: nowrap;
    text-align: center;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
